/* @flow */

import React, { Component } from 'react';
import numeral from 'numeral';
import { connect } from 'react-redux';
import glamorous from 'glamorous';
import t from 'app/utils/translate';
import {
  startMyLiveChallengesPoll,
  stopMyLiveChallengesPoll,
} from 'app/actions/myChallengesActions';
import CurrencyIcon from 'app/components/commons/CurrencyIcon';
import liveChallengesBoardSelector from '../../selectors/liveChallengesBoardSelector';
import Pulse from '../styled/Pulse';

type Props = {
  challengeId?: string,
  challenges: Array<*>,
  numEntries: number,
  startPolling: (?boolean) => void,
  stopPolling: () => void,
  totalPayout?: number,
  totalStake: number,
};

const Wrapper = glamorous.div(({ theme }) => ({
  backgroundColor: theme.color.primary,
  color: 'white',
  borderTop: '1px solid white',
  borderBottom: '1px solid white',
  padding: '0.3em',
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  fontSize: theme.fontSize.xsmall,
  fontWeight: theme.fontWeight.demiBold,
}));

const DataRow = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  '& > span': {
    padding: '0 0.2em',
    paddingTop: '0.12em',
  },
  textTransform: 'uppercase',
});

const Title = glamorous(DataRow)({
  textTransform: 'uppercase',
});

const Name = glamorous.span({});

const Value = glamorous.span(({ theme }) => ({
  fontWeight: theme.fontWeight.normal,
}));

const StyledPulse = glamorous(Pulse)({
  margin: '0 0.2em',
});

class LiveChallengesBar extends Component<Props, State> {
  props: Props;

  static defaultProps = {
    challengeId: undefined,
  };

  componentDidMount() {
    this.props.startPolling();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // attempt to keep my challenges and the challenge
    // results in sync. So if we load a challenge in, restart the poll
    // so this poll and the challenge poll should now be in sync
    if (this.props.challengeId !== nextProps.challengeId) {
      this.props.stopPolling();
      this.props.startPolling(true);
    }
  }

  componentWillUnmount() {
    this.props.stopPolling();
  }

  render() {
    const { challenges, numEntries, totalPayout, totalStake } = this.props;

    if (challenges.length === 0) return null;
    return (
      <Wrapper>
        <Title>
          <StyledPulse />
          <span>live {t('challenges')}</span>
        </Title>
        <DataRow>
          <Name>Entries</Name>
          <Value>{numEntries}</Value>
        </DataRow>
        <DataRow>
          <Name>In Play</Name>
          <Value>
            <CurrencyIcon />
            {numeral(totalStake).format('0,0.[00]')}
          </Value>
        </DataRow>
        <DataRow>
          <Name>Winning</Name>
          <Value>
            <CurrencyIcon />
            {numeral(totalPayout).format('0,0.[00]')}
          </Value>
        </DataRow>
      </Wrapper>
    );
  }
}

function mapStateToProps(state: GlobalState) {
  const { numEntries, totalStake, totalPayout, challenges } = liveChallengesBoardSelector(state);
  return {
    challengeId: state.challenge.id,
    challenges,
    numEntries,
    totalStake,
    totalPayout,
  };
}

const actions = {
  startPolling: startMyLiveChallengesPoll,
  stopPolling: stopMyLiveChallengesPoll,
};

export default connect(
  mapStateToProps,
  actions,
)(LiveChallengesBar);
